<template>
  <div class="content bg8">
      <div class="middled">
        <div class="basehero">
          <div class="tophero fpghero">
            <h1>Inspiring Founders Podcast</h1>
            <h2 class="section">Conversations with bootstrapping founders who turned challenges into momentum.</h2>
          </div>

          <p>
            Welcome to the Inspiring Founders Podcast — a new series of interviews with operators, founders, and early-stage leaders who built traction the hard way. I’m Michael “Mash” Ashley, and I’m recording conversations now; episodes start releasing in October.
          </p>

          <h3>About the Show</h3>
          <p>
            Each episode dives into practical stories: the experiments they ran, the hiring and go-to-market choices they made, the mistakes that taught them the most, and the concrete tactics other founders can put to work the next week. No fluff — just actionable lessons and honest stories from people still in the trenches.
          </p>

          <h3>Format</h3>
          <ul>
            <li><strong>Length:</strong> 30–45 minutes per episode</li>
            <li><strong>Style:</strong> Host-led interviews with a focus on decisions, metrics, and repeatable plays</li>
            <li><strong>Frequency:</strong> Weekly episodes beginning October</li>
          </ul>

          <hr>

          <h3>Meet Mash, Your Host</h3>
          <img src="@/assets/mash-michael-ashley.png" alt="Mash Michael Ashley, MBA" style="float:left;margin:0px 15px 0px 0;border-radius:50%;width:140px;height:140px;border:1px solid #ccc;">
          <p>
            Michael “Mash” Ashley is the Founder and CEO of Foclarity. With 25+ years at the intersection of strategy and execution, Mash has co-founded and scaled startups, launched and run university incubators, and worked hands-on with many founders to find focus and early traction.
          </p>
          <p>
            As a host, Mash emphasizes honest conversation, practical guidance, and real examples founders can put to work immediately. Follow the show for stories that replace theory with tactics.
          </p>

          <p style="text-align:center;margin-top:24px;">
            Subscribe now and get the first episodes in October.
          </p>

          <div class="button-row" style="justify-content:center;">
            <a href="https://mailchi.mp/327e8ef7cca3/foclarity" target="_blank" rel="nofollow">
                <button style="background: #000;color:#fff;">Subscribe</button>
            </a>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  title: "Inspiring Founders Podcast for Startup Leaders | Foclarity",
  description: 'Listen to the Inspiring Founders Podcast for practical conversations, founder stories, and lessons for startup leaders building with intention.',
  name: "InspiringFoundersPodcast",
  methods: {
    onProgramChange(event) {
      const path = event.target.value;
      if (path && path !== this.$route.path) {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style scoped>
.subnav-link {
  margin: 0 10px;
  color: #2E5077;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}
.subnav-link:hover {
  color: #7a4fa3;
  text-decoration: underline;
}
.subnav-link.router-link-exact-active {
  text-decoration: underline;
  font-weight: bold;
}
.button-row {
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  margin-bottom: 1em;
}
.button-row a {
  display: inline-block;
  @media only screen and (max-width: 440px) {
    width: 100%;
  }
}
.explore-programs-dropdown {
  margin: 40px auto 0 auto;
  max-width: 600px;
  text-align: center;
  padding: 24px 16px 18px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px 0 rgba(191,0,255,0.04);
}
.dropdown-label {
  font-weight: 600;
  color: #7a4fa3;
  font-size: 1.1rem;
  margin-bottom: 10px;
  display: block;
}
.program-select {
  width: 100%;
  max-width: 420px;
  padding: 12px 16px;
  font-size: 1.08rem;
  border: 1.5px solid #2E5077;
  border-radius: 8px;
  background: #f7f2fa;
  color: #41037b;
  font-weight: 500;
  outline: none;
  transition: border 0.2s;
  margin: 0 auto;
  box-shadow: 0 1px 4px 0 rgba(122,79,163,0.04);
}
.program-select:focus {
  border: 2px solid #7a4fa3;
}
@media (max-width: 600px) {
  .button-row {
    flex-direction: column;
    gap: 8px;
  }
  .explore-programs-dropdown {
    padding: 16px 4px 12px 4px;
  }
  .program-select {
    font-size: 1em;
    padding: 10px 8px;
    max-width: 100%;
  }
}
.fpghero {
  background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.8)),  url("~@/assets/founder-peer-groups2.jpg")no-repeat top right ;
  background-size: cover;
  min-height: 800px;
  align-content: end;
  @media only screen and (max-width: 440px) {
  background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.8)),  url("~@/assets/founder-peer-groups2.jpg")no-repeat top right ;
    background-position-y: 0px;
    background-position-x: -350px;
    background-size: 300%;
  }
}
</style>
